module.exports = __webpack_public_path__ + "epilace_2_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/dermatologie/epilace_2_before.jpg
// module id = 946
// module chunks = 0